export const Perlodin_version = "Version : 3.0.0.3";
export const Version_detail = "Version : 3.0.0.3";
export const Master_id = "O1A74iJKw-NimBe-2kp3P-m4ZzHdWKr";